import { render } from "./NotificationEditComponent.vue?vue&type=template&id=4270ac4c&scoped=true"
import script from "./NotificationEditComponent.vue?vue&type=script&lang=js"
export * from "./NotificationEditComponent.vue?vue&type=script&lang=js"

import "./NotificationEditComponent.vue?vue&type=style&index=0&id=4270ac4c&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4270ac4c"]])

export default __exports__